import { ServerError } from "./ServerError";

interface ErrorObject {
  id?: string;
  status?: string;
  code?: string;
  title?: string;
  detail?: string;
  source?: {
    pointer?: string;
  };
}

export class JSONAPIServerError extends ServerError {
  private info: ErrorObject[];

  constructor(info: ErrorObject[], url: string) {
    const [error] = info;
    super(
      error?.detail || "Unkown Error",
      url,
      error.code,
      error.source?.pointer,
    );
    this.info = info;
    console.error("Error", info);
    console.trace();
  }

  public getAllErrors(): ServerError[] {
    return this.info.map(
      (error) =>
        new ServerError(
          error?.detail || "Unkown Error",
          "",
          error.code,
          error.source?.pointer,
        ),
    );
  }
}
